import api from '../utilBackoffice';

const controller = 'ComissionamentoServicoCobrado';
const url = process.env.VUE_APP_ROOT_API + controller;

export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => api.Axios.GetParams(url, dto),
  Create: newDto => api.Axios.Post(url, newDto),
  Update: newDto => api.Axios.PutCommand(url, newDto),
  Delete: newDto => api.Axios.DeleteCommand(url, newDto)
});
